import { useState } from "react";
import { Offcanvas, Nav } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import { sidebarLinks } from "@/Data/links";
import { Menu, User } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import PcToggle from "./Istavrity/PcToggle";
import { useTheme } from "../useTheme";

export default function SideBar() {
  const [show, setShow] = useState(false);
  const { user } = useAuth();
  const canExport = user?.permissions?.includes("export_istavrity");
  const canManage = user?.permissions?.includes("manage_istavrity");
  const { theme } = useTheme();
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  // Filter links based on user permissions
  const allowedLinks = user
    ? sidebarLinks.filter((item) => {
        if (!item.permissions || item.permissions.length === 0) {
          return true;
        }
        if (!user.permissions) return false;
        return item.permissions.some((perm) => user.permissions.includes(perm));
      })
    : [];

  return (
    <>
      {/* Sidebar Toggle Button */}
      <button
        className="btn btn-secondary d-flex align-items-center"
        onClick={handleShow}
      >
        <Menu size={24} color="black" />
      </button>
      {/* Offcanvas Sidebar */}
      <Offcanvas
        show={show}
        onHide={handleClose}
        placement="start"
        className={` custom-offcanvas`}
        style={{ background: "var(--sidebar)", color: "var(--text)" }}
      >
        <Offcanvas.Header
          closeButton
          closeVariant={"white"}
        >
          <Offcanvas.Title className="fw-bold text-uppercase">
            SVNBD
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="d-flex flex-column justify-content-between pt-0">
          {/* Nav Links */}
          <Nav className="flex-column">
            {allowedLinks.length > 0 ? (
              allowedLinks.map((v) => (
                <Nav.Link
                  key={v.id}
                  as={NavLink}
                  to={v.link}
                  className={`d-flex align-items-center gap-2 py-2 sidebar-link `}
                  style={{ color: "var(--text)" }}
                  onClick={handleClose}
                >
                  <div className="me-2">{v.icon}</div>
                  <span>{v.title}</span>
                </Nav.Link>
              ))
            ) : (
              <div className="text-muted small px-2">No menu available</div>
            )}
            <Nav.Link
              key={user.username}
              as={NavLink}
              to={"/profile"}
              className={`d-flex align-items-center gap-2 py-2 sidebar-link ${
                theme === "dark" ? "text-white" : "text-dark"
              }`}
              onClick={handleClose}
            >
              <div className="me-1">
                <User />
              </div>
              <span>Profile Details</span>
            </Nav.Link>
          </Nav>
          {/* Bottom Controls */}
          <div className="border-top pt-3 mt-3 d-flex flex-column gap-3">
            {canManage && canExport && <PcToggle />}
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}
